import { render } from "./DashboardStatuspagegroups.vue?vue&type=template&id=360a3406"
import script from "./DashboardStatuspagegroups.vue?vue&type=script&lang=js"
export * from "./DashboardStatuspagegroups.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__